import axios from 'axios';
import parseModelStateErrors from '../utils/parseModelStateErrors';
import { localStorageService } from './localStorageService';

export interface IApiError {
  isCanceled?: boolean;
  errorNumber?: number;
  messages: Array<string>;
}

const instance = axios.create();

instance.defaults.headers.common.Accept = 'application/json';
instance.defaults.headers.common['Content-Type'] = 'application/json';

// https://github.com/axios/axios/issues/1383
instance.interceptors.request.use(
  function (config) {
    const token = localStorageService.getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error)  {
    if (error.isCanceled) {
      return Promise.reject(error);
    }

    const { errorNumber } = error.response.data;

    const apiError: IApiError =  {
      messages: []
    };

    if (errorNumber) {
      apiError.errorNumber = errorNumber;
    }

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (error.response.status === 401) {
        apiError.messages.push('You do not have permission to access the requested resource.');
        return Promise.reject(apiError);
      }

      // expired/invalid token
      if (errorNumber === 1001) {
        localStorageService.clearToken();
        window.location.href = window.origin;
        apiError.messages.push('Your login has expired, please wait while you are redirected back to the login page...');
        return Promise.reject(apiError);
      }

      // parse model state errors from the server
      apiError.messages = parseModelStateErrors(error.response.data);
      return Promise.reject(apiError);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      apiError.messages.push('The server could not be reached, please try again later.');
      return Promise.reject(apiError);
    } else {
      // Something happened in setting up the request that triggered an Error
      apiError.messages.push('Invalid request');
      return Promise.reject(apiError);
    }
  },
);

export { instance };
